export default function getSafe(getter, defaultValue) {
  try {
    return getter()
  } catch (e) {
    return defaultValue
  }
}
